import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../services/api'

export const useAuthStore = defineStore('auth', () => {
  const user = ref(null)
  const token = ref(localStorage.getItem('token') || null)

  const isAuthenticated = computed(() => !!token.value)

  const login = async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password })
      const { access_token, user: userData } = response.data
      
      token.value = access_token
      user.value = userData
      
      localStorage.setItem('token', access_token)
      
      // Установка токена для всех последующих запросов
      api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
      
      return { success: true }
    } catch (error) {
      console.error('Login failed:', error)
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Ошибка входа в систему' 
      }
    }
  }

  const logout = () => {
    token.value = null
    user.value = null
    localStorage.removeItem('token')
    delete api.defaults.headers.common['Authorization']
  }

  let checkAuthPromise = null

  const checkAuth = async () => {
    if (!token.value) {
      return false
    }

    if (user.value) {
      return true
    }

    if (checkAuthPromise) {
      return checkAuthPromise
    }

    checkAuthPromise = (async () => {
      try {
        const response = await api.get('/auth/me')
        user.value = response.data
        return true
      } catch (error) {
        console.error('checkAuth - Auth failed:', error)
        logout()
        return false
      } finally {
        checkAuthPromise = null
      }
    })()

    return checkAuthPromise
  }

  const getDefaultRoute = () => {
    if (!user.value) return '/login'
    // Все роли перенаправляются на главную страницу
    return '/'
  }

  // Проверка аутентификации при инициализации
  if (token.value) {
    // Устанавливаем токен в API defaults сразу
    api.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
    // Проверяем авторизацию
    checkAuth()
  }

  return {
    user,
    token,
    isAuthenticated,
    login,
    logout,
    checkAuth,
    getDefaultRoute
  }
})
